import React, { useContext, useEffect, useState } from "react";
import { Menu, type MenuProps, theme } from "antd";
import Sider from "antd/es/layout/Sider";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { TiDocumentText } from "react-icons/ti";
import { FaUsers, FaArrowLeft } from "react-icons/fa";
import { AuthContext } from "../../../../config/AuthContext";
import { GetPractica } from "../../../../dao/bbdd/GetPracticaId";

interface Props {
    setPantalla: (value: number) => void;
    initialPantalla: number;
}

const AppSiderActivitatsId = (props: Props) => {
    const { user } = useContext(AuthContext);
    const { id_activitat } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const isTeacher = user.tipus === "0" || user.tipus === "1";

    // Detectem si l'activitat és un examen per fer que "Tornar enrere" apunti a /database/examens.
    const [esExamen, setEsExamen] = useState(false);
    useEffect(() => {
        let cancel = false;
        (async () => {
            if (!id_activitat) return;
            try {
                const act: any = await GetPractica(id_activitat + "");
                if (!cancel) setEsExamen(Boolean(act?.isExamen || Number(act?.is_examen) === 1));
            } catch (_) { /* ignore */ }
        })();
        return () => { cancel = true; };
    }, [id_activitat]);

    const isAlumnesPage = location.pathname.includes('/alumnes') || props.initialPantalla === 1;
    const selectedKey = isAlumnesPage ? 'alumnes' : 'exercicis';

    const menuItems: MenuProps['items'] = [
        {
            key: 'back',
            icon: <FaArrowLeft />,
            label: 'Tornar enrere',
            onClick: () => navigate(esExamen ? '/database/examens' : '/database/activitats')
        },
        {
            type: 'divider'
        },
        {
            key: 'exercicis',
            icon: <TiDocumentText style={{ fontSize: 18 }} />,
            label: 'Exercicis',
            onClick: () => {
                props.setPantalla(0);
                navigate(`/database/activitats/${id_activitat}`);
            }
        },
        ...(isTeacher ? [{
            key: 'alumnes',
            icon: <FaUsers style={{ fontSize: 18 }} />,
            label: 'Seguiment Alumnes',
            onClick: () => {
                props.setPantalla(1);
                navigate(`/database/activitats/${id_activitat}/alumnes`);
            }
        }] : [])
    ];

    const {
        token: { colorBgContainer },
    } = theme.useToken();

    return (
        <Sider style={{ background: colorBgContainer }} width={210}>
            <Menu
                mode="inline"
                selectedKeys={[selectedKey]}
                style={{ height: '100%', borderRight: 0 }}
                items={menuItems}
            />
        </Sider>
    );
};

export default AppSiderActivitatsId;